import { render, staticRenderFns } from "./DetailAssesment.vue?vue&type=template&id=75555336&scoped=true&"
import script from "./DetailAssesment.vue?vue&type=script&lang=js&"
export * from "./DetailAssesment.vue?vue&type=script&lang=js&"
import style0 from "./DetailAssesment.vue?vue&type=style&index=0&id=75555336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75555336",
  null
  
)

export default component.exports